import store from "../redux/store";
import axios from "../AxiosClient";
import { authServiceClient } from "../AxiosClient";
import { setLicence } from "../redux/actions/universalActions";

export const fetchLicence = () => {
  authServiceClient.get("/licence/current").then((res) => {
    store.dispatch(setLicence(res.data))
  });
};

export const documentLimitReached = () => {
  let licence = store.getState().setting.licence;
  let currentUser = store.getState().user.currentUser;
  if (!licence.usedDocuments) {
      axios.get(`/document/usage/${currentUser.organization.organizationId}`).then((usage) => {
        licence.usedDocuments = usage.data
        store.dispatch(setLicence(licence));
        return licence.usedDocuments >= licence.documents;
      })
  } else {
    return licence.usedDocuments >= licence.documents;
  }
};
